export default __webpack_public_path__ + "static/ePwMxLOK-c2208ed66f449c64c6b1a38cc3738bf8.svg";